// extracted by mini-css-extract-plugin
export var inputContainer = "_nx-0";